import { useCallback, useState } from 'react';
import axios from 'ggApp/utils/requests';

interface HookProps {
    orderNumber: string;
    voucher: string;
}

interface HookResult {
    voucherResponse: object | null;
    voucherError: object | null;
    applyVoucher: () => Promise<void>;
}
// NOTE: move it to common in case when its used in more than one place;
export const useVoucher = ({ orderNumber, voucher }: HookProps): HookResult => {
    const [voucherResponse, setVoucherResponse] = useState<null | object>(null);
    const [voucherError, setVoucherError] = useState<null | object>(null);
    const applyVoucher = useCallback((): Promise<void> => {
        if (!orderNumber || !voucher) return Promise.reject();
        return axios
            .patch(`orders/${orderNumber}/apply_coupon`, { coupon_code: voucher })
            .then((res: { data: object }) => {
                setVoucherResponse(res.data);
            })
            .catch(setVoucherError);
    }, [orderNumber, voucher]);

    return { applyVoucher, voucherResponse, voucherError };
};
